import { MAILING_TEMPLATES, type MailingTemplateMeta } from "./templates";

interface Props {
  open: boolean;
  onClose: () => void;
  onPick: (template: MailingTemplateMeta) => void;
}

export function TemplatePicker({ open, onClose, onPick }: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4" onClick={onClose}>
      <div
        className="max-h-[85vh] w-full max-w-3xl overflow-y-auto rounded-lg bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-5 flex items-start justify-between">
          <div>
            <h2 className="text-xl font-semibold text-tvs-blue">Reiniciar plantilla</h2>
            <p className="mt-1 text-sm text-slate-500">
              Vas a perder los cambios actuales y volver al mailing oficial vacío. ¿Continuar?
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
            className="text-slate-400 hover:text-slate-700"
          >
            ✕
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {MAILING_TEMPLATES.map((tpl) => (
            <button
              key={tpl.id}
              type="button"
              onClick={() => onPick(tpl)}
              className="group flex flex-col items-start gap-2 rounded-lg border border-slate-200 bg-white p-4 text-left transition-all hover:border-tvs-blue hover:shadow-soft"
            >
              <h3 className="font-semibold text-tvs-blue group-hover:text-tvs-blue-dark">{tpl.label}</h3>
              <p className="text-sm text-slate-600">{tpl.description}</p>
            </button>
          ))}
        </div>

        <div className="mt-5 flex justify-end">
          <button type="button" onClick={onClose} className="btn-secondary text-sm">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
